/* eslint-disable no-underscore-dangle */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useEffect, useMemo, useRef, useCallback, SetStateAction } from "react";
import { makeStyles } from "@material-ui/core";
import { Map as ImmutableMap, update } from 'immutable';
import hash from "object-hash";
import { QueueCallState, Summary, Delta, UserState } from "./QueueLeaderboard";
import Widget from "./Widget";
import WidgetCompact from "./WidgetCompact";
import CompactViewHeader from "./NEW/CompactViewHeader";

export interface WidgetMetric {
  duration: number;
  weight: number;
}

export interface AgentInfo {
  name: string,
  status: string,
}

export interface MetricObject {
  waiting: Array<{
    callId: string;
    timestamp: Date;
    phoneNumber: string;
  }>;
  inProgress: Array<{
    callId: string;
    timestamp: Date;
  }>;
  answered: WidgetMetric;
  abandoned: WidgetMetric;
  voiceMail: WidgetMetric;
  missed: WidgetMetric;
  available: number;
  busy: number;
  unavailable: number;
  agents: {
    name: string;
    id: string;
    displayStatus: string;
    availableAccepting: boolean,
    busyAccepting: boolean,
    notAccepting: boolean,
    department: string;
    status: string,
    portrait: string,
    onQueueCall: any
  }[];

}

const QueueWidgetContainer = React.memo(({
  excluded,
  historicalQueues,
  mode,
  queueCallStates,
  leaderboardDeltas,
  sidebar,
  legacy,
  historicalUsers,
  toggledQueues,
  setToggledQueues,
  userSortOrder,
  queueCompactView,
  userSortField,
  userSortDirection,
  adminClick,
  queueDisplay,
  queueSortOrder,
  queueSortField,
  showPortraits,
  compactWidgetMetrics,
  showDnd,
  showBusy,
  showInvisible,
  showAvailable,
  fullscreen,
  setFullscreen,
  userState,
  setLiveQueueMetrics,
  setQueueCallStates,
  orgId,
}: {
  excluded: Set<string>;
  historicalQueues: ImmutableMap<string, any>;
  historicalUsers: ImmutableMap<string, any>;
  mode: string;
  queueCallStates: Array<QueueCallState>;
  leaderboardDeltas: Array<Delta>;
  sidebar: boolean;
  legacy: boolean;
  toggledQueues: Map<string, string>;
  setToggledQueues: React.Dispatch<SetStateAction<Map<string, string>>>
  queueCompactView: boolean;
  userSortOrder: string | undefined;
  userSortDirection: any
  userSortField: any;
  adminClick: (string: string) => void;
  queueDisplay: string | undefined;
  queueSortOrder: string | undefined;
  queueSortField: string | undefined;
  showPortraits: boolean | undefined;
  compactWidgetMetrics: Array<{key: string, label: string, visible: boolean}> | undefined;
  showDnd: boolean;
  showBusy: boolean;
  showInvisible: boolean;
  showAvailable: boolean;
  fullscreen: string | undefined;
  setFullscreen: React.Dispatch<SetStateAction<string | undefined>>;
  userState: ImmutableMap<string, UserState>;
  setLiveQueueMetrics: React.Dispatch<SetStateAction<Map<string, MetricObject>>>;
  setQueueCallStates: any;
  orgId: string;
}) => {

  const modified = useRef<Set<string>>(new Set(historicalQueues.keys()));
  const lastExcluded = useRef<Set<string>>(new Set(excluded));
  const renderedWidgetsRef = useRef<Map<string, JSX.Element>>(new Map());
  const [metricQueues, setMetricQueues] = useState<ImmutableMap<string, MetricObject>>(ImmutableMap());
  const [compactView, setCompactView] = useState(queueCompactView)
  const [_userSortDirection, _setUserSortDirection] = useState(userSortDirection)
  const [_userSortField, _setUserSortField] = useState(userSortField)
  const [_userSortOrder, _setUserSortOrder] = useState(userSortOrder)
  const [_queueDisplay, _setQueueDisplay] = useState(queueDisplay)
  const [_queueSortOrder, _setQueueSortOrder] = useState(queueSortOrder)
  const [_queueSortField, _setQueueSortField] = useState(queueSortField)
  const [_showPortraits, setShowPortraits] = useState(showPortraits)
  const [_compactWidgetMetrics, _setCompactWidgetMetrics] = useState(compactWidgetMetrics)
  const [presenceStatuses, setPresenceStatuses] = useState({
    _showAvailable: showAvailable,
    _showBusy: showBusy,
    _showDnd: showDnd,
    _showInvisible: showInvisible
  })
  const [_fullscreen, _setFullscreen] = useState<string | undefined>(fullscreen)
  const [_userStates, _setUserStates] = useState<Map<string, UserState>>(new Map(userState))
  // reset everything...


  useEffect(() => {
    _setUserStates(new Map(userState))
    console.log("QWidgetContainer-UserState: ", userState);
  }, [userState])

  useEffect(() => {
    setPresenceStatuses({
      _showAvailable: showAvailable,
      _showBusy: showBusy,
      _showDnd: showDnd,
      _showInvisible: showInvisible
    })
  }, [showAvailable, showBusy, showDnd, showInvisible])

  useEffect(() => {
    _setFullscreen(fullscreen)
  }, [fullscreen])
  useEffect(() => {
    _setUserSortOrder(userSortOrder)
  }, [userSortOrder])

  useEffect(() => {
    _setUserSortField(userSortField)
  }, [userSortOrder])

  useEffect(() => {
    _setUserSortDirection(userSortDirection)
  }, [userSortDirection])

  useEffect(() => {
    _setQueueDisplay(queueDisplay)
  }, [queueDisplay])

  useEffect(() => {
    _setQueueSortOrder(queueSortOrder)
  }, [queueSortOrder])

  useEffect(() => {
    _setQueueSortField(queueSortField)
  }, [queueSortField])
  
  useEffect(() => {
    setCompactView(queueCompactView)
  }, [queueCompactView])

  useEffect(() => {
    _setCompactWidgetMetrics(compactWidgetMetrics)
  }, [compactWidgetMetrics])

  useEffect(() => {
    modified.current = new Set(historicalQueues.keys());
  }, [mode, sidebar, legacy, queueCompactView, compactView, _userSortDirection, _userSortField, _userSortOrder, _queueSortField, _queueDisplay, _queueSortOrder, _compactWidgetMetrics, compactWidgetMetrics, showAvailable, showBusy, showDnd, showInvisible, fullscreen, userState, _userStates])

  const handleQueueToggle = useCallback((queue: string) => {
    setToggledQueues((previousQueues) => {
      const copyOfQueues = new Map(previousQueues);
      const existingQueue = copyOfQueues.get(queue)
      if (existingQueue) {
        copyOfQueues.delete(queue)
      }
      else {
        copyOfQueues.set(queue, queue)
      }
      return copyOfQueues;
    })
    modified.current = new Set(historicalQueues.keys()).add(queue)
  }, [toggledQueues])

  useEffect(() => {
    setMetricQueues((oldMetricQueues) => {
     const updatedMap = oldMetricQueues.withMutations((mutableMap) => {
        queueCallStates.forEach((record) => {
          if (record.queueId) {
            const historicalQueue = historicalQueues.get(record.queueId);
            if (historicalQueue) {
              const currentMetric = mutableMap.get(record.queueId) || {
                waiting: [],
                inProgress: [],
                answered: { duration: 0, weight: 0 },
                abandoned: { duration: 0, weight: 0 },
                voiceMail: { duration: 0, weight: 0 },
                missed: { duration: 0, weight: 0 },
                available: 0,
                busy: 0,
                unavailable: 0,
                agents: [],
              };

              const updatedMetrics = { ...currentMetric };

              if (record.userId !== undefined) {
                if (record.state === "TALKING") {
                  const existing = updatedMetrics.inProgress.find(
                    (prog) => prog.callId === record.callId
                  );

                  if (!existing) {
                    updatedMetrics.inProgress = [
                      ...updatedMetrics.inProgress,
                      {
                        callId: record.callId,
                        timestamp: new Date(record.time),
                      },
                    ];
                  } else {
                    updatedMetrics.inProgress = updatedMetrics.inProgress.map((prog) =>
                      prog.callId === record.callId &&
                        new Date(record.time).getTime() < prog.timestamp.getTime()
                        ? {
                          callId: record.callId,
                          timestamp: new Date(record.time),
                        }
                        : prog
                    );
                  }
                } else {
                  updatedMetrics.inProgress = updatedMetrics.inProgress.filter(
                    (prog) =>
                      prog.callId !== record.callId ||
                      prog.timestamp.getTime() > new Date(record.time).getTime()
                  );
                }
              } else if (record.state === "RINGING") {
                const existing = updatedMetrics.waiting.find(
                  (wait) => wait.callId === record.callId
                );

                if (!existing) {
                  updatedMetrics.waiting = [
                    ...updatedMetrics.waiting,
                    {
                      callId: record.callId,
                      timestamp: new Date(record.time),
                      phoneNumber: (Array.isArray(record.from)
                        ? record.from[0]
                        : record.from
                      )?.phoneNumber,
                    },
                  ];
                } else {
                  updatedMetrics.waiting = updatedMetrics.waiting.map((wait) => {
                    if (wait.callId === record.callId) {
                      if (
                        new Date(record.time).getTime() < wait.timestamp.getTime()
                      ) {
                        return {
                          callId: record.callId,
                          timestamp: new Date(record.time),
                          phoneNumber:
                            (Array.isArray(record.from)
                              ? record.from[0]
                              : record.from
                            )?.phoneNumber || wait.phoneNumber,
                        };
                      }
                      return {
                        callId: record.callId,
                        timestamp: wait.timestamp,
                        phoneNumber:
                          wait.phoneNumber ||
                          (Array.isArray(record.from) ? record.from[0] : record.from)
                            ?.phoneNumber,
                      };
                    }
                    return wait;
                  });
                }
              } else {
                updatedMetrics.waiting = updatedMetrics.waiting.filter(
                  (wait) =>
                    wait.callId !== record.callId ||
                    wait.timestamp.getTime() > new Date(record.time).getTime()
                );
              }
              mutableMap.set(record.queueId, updatedMetrics);
              modified.current.add(record.queueId);

            }
          }
        });
      });
      setLiveQueueMetrics(new Map(updatedMap))
      return updatedMap;
    }
    );
  }, [queueCallStates]);

  // Hung call garbage collector... Yucky...

  const collectGarbage = useCallback(() => {
    const now = Date.now();
    const TIMEOUT = 15 * 60 * 1000;
    // const TIMEOUT = 30 * 1000;

    metricQueues.forEach((metric, key) => {
      for(const waitingCall of metric.waiting) {
      const waitingTime = new Date(waitingCall.timestamp).getTime();
        if (now - waitingTime > TIMEOUT) {
          // Clean up garbage call
          const syntheticEnd = {
            state: "QUEUE ABANDONED",
            time: new Date().toISOString(),
            callId: waitingCall.callId,
            queueId: key,
          }
          console.log('Garbage metric:', key, metric, syntheticEnd);
          setQueueCallStates([syntheticEnd]);
        }
      }
    });
  }, [metricQueues]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if(orgId === "3221779015") {
      let isCancelled = false;
      const TIMEOUT = 30000;
      const runTimeout = () => {
        if (isCancelled) return;
        collectGarbage();
        setTimeout(runTimeout, TIMEOUT);
      };
      collectGarbage();
      const timeoutId = setTimeout(runTimeout, TIMEOUT);
      return () => {
        isCancelled = true;
        clearTimeout(timeoutId);
      };
    }
  }, [collectGarbage]);

  useEffect(() => {
    if (leaderboardDeltas.length === 0) {
      return;
    }

    setMetricQueues((oldMetricQueues) => oldMetricQueues.withMutations((mutableMap) => {
      leaderboardDeltas.forEach((delta: Delta) => {
        const historicalQueue = historicalQueues.get(delta.userId);
        if (!historicalQueue) {
          return;
        }
        const currentMetrics = mutableMap.get(delta.userId) || {
          waiting: [],
          inProgress: [],
          answered: { duration: 0, weight: 0 },
          abandoned: { duration: 0, weight: 0 },
          voiceMail: { duration: 0, weight: 0 },
          missed: { duration: 0, weight: 0 },
          available: 0,
          busy: 0,
          unavailable: 0,
          agents: [],
        };

        const updatedMetrics = { ...currentMetrics };
        if (delta.abandonedCount) {
          updatedMetrics.abandoned = {
            duration: currentMetrics.abandoned.duration + (delta.abandonedTime || 0),
            weight: currentMetrics.abandoned.weight + (delta.abandonedCount || 0),
          };
        }

        if (delta.answeredCount) {
          updatedMetrics.answered = {
            duration: currentMetrics.answered.duration + (delta.answeredTime || 0),
            weight: currentMetrics.answered.weight + (delta.answeredCount || 0),
          };
        }

        if (delta.missedCount) {
          updatedMetrics.missed = {
            duration: currentMetrics.missed.duration + (delta.missedTime || 0),
            weight: currentMetrics.missed.weight + (delta.missedCount || 0),
          };
        }

        if (delta.voicemailCount) {
          updatedMetrics.voiceMail = {
            duration: currentMetrics.voiceMail.duration + (delta.voicemailTime || 0),
            weight: currentMetrics.voiceMail.weight + (delta.voicemailCount || 0),
          };
        }
        mutableMap.set(delta.userId, updatedMetrics);
        modified.current.add(delta.userId);
      });
    }));
  }, [leaderboardDeltas]);

  useEffect(() => {
    setMetricQueues((oldMetricQueues) => oldMetricQueues.withMutations((mutableMap) => {
      historicalQueues.forEach(queue => {
        const currentMetrics = mutableMap.get(queue.id) || {
          waiting: [],
          inProgress: [],
          answered: { duration: 0, weight: 0 },
          abandoned: { duration: 0, weight: 0 },
          voiceMail: { duration: 0, weight: 0 },
          missed: { duration: 0, weight: 0 },
          available: 0,
          busy: 0,
          unavailable: 0,
          agents: [],
        };
        const updatedMetrics = { ...currentMetrics };
        updatedMetrics.available = 0;
        updatedMetrics.busy = 0;
        updatedMetrics.unavailable = 0;

        const agents = queue.users.map((user: { id: string, acceptCurrentQueueCalls: boolean , acceptQueueCalls: boolean}) => {
            const agent = historicalUsers.get(user.id);
            if(agent) {
            let availableAccepting; let busyAccepting; let notAccepting = false;
            if (user.acceptCurrentQueueCalls) {
              if (agent.lastPresenceStatus === "Available" && agent.lastDndStatus === "TakeAllCalls") {
                updatedMetrics.available += 1;
                availableAccepting = true;
              } else if (agent.lastPresenceStatus === "Busy" && !agent.display.startsWith("DND")) {
                updatedMetrics.busy += 1;
                busyAccepting = true;
              } else {
                updatedMetrics.unavailable += 1;
                notAccepting = true
              }
            } else if (agent.lastDndStatus !== "TakeAllCalls" && !user.acceptCurrentQueueCalls) {
              updatedMetrics.unavailable += 1;
              notAccepting = true
            }
            return  {
              name: `${agent.firstName} ${agent.lastName} ${agent.extensionNumber ? `(${agent.extensionNumber})` : ""}`, 
              firstName: agent?.firstName,
              lastName: agent?.lastName,
              emergency: agent?.emergency,
              extensionNumber: agent?.extensionNumber,
              id: agent.id,
              displayStatus: agent.display || "AVL:Available",
              availableAccepting,
              busyAccepting,
              notAccepting,
              department: agent.department,
              status: agent.status,
              lastDndStatus: agent?.lastDndStatus,
              lastPresenceStatus: agent?.lastPresenceStatus,
              lastMessage: agent?.lastMessage,
              acceptQueueCalls: user.acceptQueueCalls,
              acceptCurrentQueueCalls: user.acceptCurrentQueueCalls,
              portrait: agent?.uri || "./default-user-image.ico",
              onQueueCall: new Map(_userStates).get(agent.id) || undefined // MIGHT BE SIGNIFICANT
            }
          } 
          else {
            console.log("Agent not found for user:", user);
            return {
              name: `Unknown User (${user.id})`, 
              firstName: "Unknown",
            }
          }
        });
        updatedMetrics.agents = agents;
        if(hash(currentMetrics) !== hash(updatedMetrics)) {
          mutableMap.set(queue.id, updatedMetrics);
          modified.current.add(queue.id);
        }
      })
    }));
  }, [historicalUsers, historicalQueues, queueCompactView, userSortDirection, userSortOrder, userSortField, queueSortField, queueSortOrder, compactWidgetMetrics, showAvailable, showBusy, showDnd, showInvisible, fullscreen, userState, _userStates]);


  useEffect(() => {
    const added = [...excluded].filter(item => !lastExcluded.current.has(item));
    const removed = [...lastExcluded.current].filter(item => !excluded.has(item));
    for(const item of [...added, ...removed]) {
      modified.current.add(item);
    }
    lastExcluded.current = new Set(excluded);
  }, [excluded, queueCompactView, userSortDirection, userSortOrder, userSortField, queueSortField, queueSortOrder, queueDisplay, compactWidgetMetrics, showAvailable, showBusy, showDnd, showInvisible, fullscreen, userState]);

  const renderedWidgets = useMemo(() => {
    const newRenderedWidgets = new Map(renderedWidgetsRef.current);
    // Iterate only over modified queueIds
    // eslint-disable-next-line no-restricted-syntax
    for (const queueId of modified.current) {
      const queue = historicalQueues.get(queueId);
      // eslint-disable-next-line no-continue
      if (!queue) continue;
  
      const queueMetrics = metricQueues.get(queueId);
        newRenderedWidgets.set(
          queueId,
          compactView ? (
            <WidgetCompact
            excluded={excluded.has(queueId)}
            queueCompactView={queueCompactView}
            queueDisplay={queueDisplay}
            toggled={!!toggledQueues.get(queueId)}
            key={queueId}
            queueId={queueId}
            queueName={queue.name}
            extension={queue.extensionNumber}
            waiting={queueMetrics?.waiting || []}
            inProgress={queueMetrics?.inProgress.length || 0}
            answered={queueMetrics?.answered || { duration: 0, weight: 0 }}
            abandoned={queueMetrics?.abandoned || { duration: 0, weight: 0 }}
            voicemail={queueMetrics?.voiceMail || { duration: 0, weight: 0 }}
            missed={queueMetrics?.missed || { duration: 0, weight: 0 }}
            mode={mode}
            sidebar={sidebar}
            legacy={legacy}
            handleQueueToggle={() => handleQueueToggle(queueId)}
            agents={queueMetrics?.agents || []}
            available={queueMetrics?.available || 0}
            busy={queueMetrics?.busy || 0}
            _setFullscreen={_setFullscreen}
            unavailable={queueMetrics?.unavailable || 0}
            userSortOrder={_userSortOrder}
            userSortField={_userSortField}
            userSortDirection={_userSortDirection}
            queueSortOrder={_queueSortOrder}
            queueSortField={_queueSortField}
            adminClick={adminClick}
            showPortraits={_showPortraits}
            compactWidgetMetrics={_compactWidgetMetrics}
            showAvailable={presenceStatuses._showAvailable}
            showDnd={presenceStatuses._showDnd}
            showBusy={presenceStatuses._showBusy}
            showInvisible={presenceStatuses._showInvisible}
          />  
          ) : ( 
            <Widget
            excluded={excluded.has(queueId)}
            queueCompactView={queueCompactView}
            toggled={!!toggledQueues.get(queueId)}
            key={queueId}
            queueId={queueId}
            queueName={queue.name}
            extension={queue.extensionNumber}
            waiting={queueMetrics?.waiting || []}
            inProgress={queueMetrics?.inProgress.length || 0}
            answered={queueMetrics?.answered || { duration: 0, weight: 0 }}
            abandoned={queueMetrics?.abandoned || { duration: 0, weight: 0 }}
            voicemail={queueMetrics?.voiceMail || { duration: 0, weight: 0 }}
            missed={queueMetrics?.missed || { duration: 0, weight: 0 }}
            mode={mode}
            sidebar={sidebar}
            legacy={legacy}
            handleQueueToggle={() => handleQueueToggle(queueId)}
            agents={queueMetrics?.agents || []}
            available={queueMetrics?.available || 0}
            busy={queueMetrics?.busy || 0}
            unavailable={queueMetrics?.unavailable || 0}
          />
          )
        )      
    }
  
    // Clear the modified set after rendering
    modified.current.clear();
    renderedWidgetsRef.current = newRenderedWidgets;
    return Array.from(newRenderedWidgets.values())
    
  }, [excluded, metricQueues, mode, sidebar, legacy, toggledQueues, compactView, _userSortOrder, _userSortDirection, _userSortField, _queueSortField, _queueDisplay, _queueSortOrder, _compactWidgetMetrics, presenceStatuses, _fullscreen, _userStates]);
  

  return <span style={{background: mode === 'light' ? "white" : "#333333"}} className={`${!compactView ? "widget-item-container-legacy" : "widget-item-container"} ${sidebar ? "sidebar-open" : ""} ${mode === 'light' ? "light" : "dark"}`}>
    {renderedWidgets.sort((a, b) => {

  if (_queueSortField === 'extensionNumber') {
    return _queueSortOrder === 'asc'
      ? Number(a.props.extension)- Number(b.props.extension)
      : Number(b.props.extension) - Number(a.props.extension);
  }
  if (_queueSortField === 'name') {
    return _queueSortOrder === 'asc'
      ? a.props.queueName.localeCompare(b.props.queueName)
      : b.props.queueName.localeCompare(a.props.queueName);
  }
  if (_queueSortField === 'waiting') {
    if ((a.props.waiting?.size || 0) !== (b.props.waiting?.size || 0)) {
        return _queueSortOrder === "asc" 
        ? (a.props.waiting?.size || 0) - (b.props.waiting?.size || 0)
        : (b.props.waiting?.size || 0) - (a.props.waiting?.size || 0)
    }
  }
  if (_queueSortField === 'longestRinging') {
    const aRingTime = (Array.from(a.props.waiting?.values() || []) as Array<string>).reduce((sum: string | undefined, time: string) => {
      if (sum === undefined || sum > time) return time
      return sum;
    }, undefined);
    const bRingTime = (Array.from(b.props.waiting?.values() || []) as Array<string>).reduce((sum: string | undefined, time: string) => {
      if (sum === undefined || sum > time) return time;
      return sum;
    }, undefined);
    if ((aRingTime || "") > (bRingTime || ""))return _queueSortOrder === "asc" ? 1 : -1;
    if ((aRingTime || "") < (bRingTime || ""))return _queueSortOrder === "asc" ? -1 : 1;
  }
  if (_queueSortField === 'agentsAvailable') {
    const aAgents = a.props.agents.filter((agent: {acceptQueueCalls: boolean, acceptCurrentQueueCalls: boolean}) => agent.acceptCurrentQueueCalls && agent.acceptQueueCalls).length;
    const bAgents = b.props.agents.filter((agent: {acceptQueueCalls: boolean, acceptCurrentQueueCalls: boolean}) => agent.acceptCurrentQueueCalls && agent.acceptQueueCalls).length;
    if ((aAgents || 0) !== (bAgents || 0)) {
      if (_queueSortOrder === "asc") return (aAgents || 0) - (bAgents || 0);
      return (bAgents || 0) - (aAgents || 0);
    }
  }
    return _queueSortOrder === 'asc'
    ? Number(a.props.extension)- Number(b.props.extension)
    : Number(b.props.extension) - Number(a.props.extension);
  })}
    </span>

});

export default QueueWidgetContainer;